import { GET, GET_WARRANTY_FULL_SEARCH } from '../../../../services';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { openAlert } from '../../../../components/alert/hooks';

export const useGetWarrantyFull = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(
        GET_WARRANTY_FULL_SEARCH({
          search: search || '',
        }),
      );
      return response.result.items || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
    onError: (error) => {
      openAlert({ type: 'error', model: 'message', message: error?.message || 'เกิดข้อผิดพลาด' });
    },
  });

  const onFetchFull = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetchFull };
};
